import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { SortingHeaderButton } from '../../../../components/ui/DataTable/SortingHeaderButton'
import { NumberBadge } from '@/components/ui/DataTable/NumberBadge'
import { RowActionsMenu } from './RowActionsMenu'
import { Badge } from '@/components/shadcn/badge'

export type MessagesApplicationsPage = RestSchemas['Messages.Applications.Page']

export const appPagesTableColumnsV2: ColumnDef<MessagesApplicationsPage>[] = [
  {
    id: 'pageId',
    // accessorFn: (row) => `${row.name} ${row.description}`,
    accessorFn: (row) => row.id,
    header: ({ column }) => <SortingHeaderButton column={column}>Page ID</SortingHeaderButton>,
    cell: ({ row }) => (
      <Badge variant="secondary" className="font-normal">
        {row.original.id}
      </Badge>
    ),
    sortingFn: (rowA, rowB) => rowA.original.id?.localeCompare(rowB.original.id ?? '') ?? 0,
    enableGlobalFilter: true,
    size: 250,
  },
  {
    id: 'description',
    accessorKey: 'description',
    header: 'Description',
    cell: ({ cell }) => cell.getValue() as string,
    enableGlobalFilter: true,
  },
  {
    id: 'pageInfo',
    accessorKey: 'pageInfo',
    header: 'Page Info',
    cell: ({ cell }) => cell.getValue() as string,
    enableGlobalFilter: true,
  },
  {
    id: 'actions',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <RowActionsMenu row={row.original} />
      </div>
    ),
  },
]
